/* eslint-disable no-shadow */
import { FormFields, FormValidationSchema } from '@/common/interfaces';
import { Domain } from './entities/Domain.entity';

export type DomainDeploymentInfo = Pick<
  Domain,
  'isConfigured' | 'isDeployed' | 'deployStatus' | 'name' | 'configurationStatus' | 'configurationErrorMessage'
> & {
  configInfo: DomainConfigInfo | null;
};

export type DomainConfigInfo = {
  [x in keyof Pick<
    Domain,
    | 'staticPrefix'
    | 'isHttps'
    | 'wwwRedirect'
    | 'schemeRedirect'
    | 'proxyServer'
    | 'proxyServerAddress'
    | 'dnsRecord'
    | 'site'
  >]: NonNullable<Domain[x]>;
};

export enum DomainDeployStatus {
  NotDeployed = 'notDeployed',
  Deployed = 'deployed',
  Failed = 'failed',
  Deploying = 'deploying',
  Shutdowning = 'shutdowning',
  Pending = 'pending'
}

export enum DomainConfigurationStatus {
  NotConfigured = 'notConfigured',
  Pending = 'pending',
  Attaching = 'attaching',
  Detaching = 'detaching',
  Failed = 'failed',
  Configured = 'configured',
}

export enum DomainWWWRedirect {
  None = 'none',
  WWWToWithoutWWW = 'wwwToWithoutWww',
  WithoutWWWToWWW = 'withoutWwwToWww'
}

export enum DomainSchemeRedirect {
  None = 'none',
  HttpToHttps = 'httpToHttps',
  HttpsToHttp = 'httpsToHttp'
}

export enum DomainFormInputs {
  Names = 'names',
  RegistratedAt = 'registratedAt',
  PaidAt = 'paidAt',
  DomainRegistrarId = 'domainRegistrarId',
  DomainRegistrarAccountId = 'domainRegistrarAccountId'
}

export type DomainFormFields = FormFields<typeof DomainFormInputs>;

export type DomainFormValidationSchema = FormValidationSchema<DomainFormFields>;

export enum DomainConfigFormInputs {
  SiteId = 'siteId',
  IsHttps = 'isHttps',
  ProxyServerId = 'proxyServerId',
  ProxyServerAddressId = 'proxyServerAddressId',
  DnsRecordId = 'dnsRecordId',
  WwwRedirect = 'wwwRedirect',
  SchemeRedirect = 'schemeRedirect',
  StaticPrefix = 'staticPrefix'
}

export type DomainConfigFormFields = FormFields<typeof DomainConfigFormInputs>;

export type DomainConfigFormValidationSchema = FormValidationSchema<DomainConfigFormFields>;

export interface DomainDeploymentError {
  dnsError: {
    isError: boolean;
    errorMessage: string | null;
  };
  deploytionError: {
    isError: boolean;
    errorMessage: string | null;
  };
}

export interface DnsChangesInDomainOnConfigAttachResult {
  changeStatus: 'error' | 'success' | 'notDefined';
  message: string;
}

export enum DomainVisitors {
  Any = 'any',
  Person = 'person',
  GoogleBot = 'googlebot'
}

export const DOMAIN_VISITOR_OPTIONS: { value: DomainVisitors; label: string }[] = [
  { value: DomainVisitors.Any, label: 'Будь-хто' },
  { value: DomainVisitors.GoogleBot, label: 'Google Bot' },
  { value: DomainVisitors.Person, label: 'Людина' },
];

export const getDomainVisitorLabel = (forVisitor: DomainVisitors): string =>
  DOMAIN_VISITOR_OPTIONS.find((option) => option.value === forVisitor)?.label ?? forVisitor;

export enum DomainRegluingsFormInputs {
  ForVisitor = 'forVisitor',
  TargetDomainId = 'targetDomainId',
  OriginDomainId = 'originDomainId',
  SiteId = 'siteId',
  IsAutoUpdate = 'isAutoUpdate'
}

export type DomainRegluingsFormFields = FormFields<typeof DomainRegluingsFormInputs>;

export type DomainRegluingsFormValidationSchema = FormValidationSchema<DomainRegluingsFormFields>;

export enum DomainDeploymentGatewayKeys {
  UpdateDeployStatus = 'updateDeployStatus',
}

export enum DomainGatewayKeys {
  UpdateHealthStatus = 'updateHealthStatus',
  UpdateConfigurationStatus = 'updateConfigurationStatus',
}

export enum DomainAutoRegluingsFormInputs {
  ForVisitor = 'forVisitor',
  IsEnabled = 'isEnabled'
}

export type DomainAutoRegluingsFormFields = FormFields<typeof DomainAutoRegluingsFormInputs>;

export type DomainAutoRegluingsFormValidationSchema = FormValidationSchema<DomainAutoRegluingsFormFields>;

export enum DomainHealthStatus {
  Working = 'working',
  Checking = 'checking',
  NotWorking = 'notWorking'
}
